import React, { Component } from "react";
import { Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import Functions from "../../../src/util/functions";

export default class ResetPassword extends Component {
    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background reset-password">
                    <Banner heading="Change your password" />
                    <Row>
                        <Col xs={12} sm={10} smOffset={1} md={6} mdOffset={3} lg={4} lgOffset={4}>
                            <Form className="new_user" id="new_user" action="/users/password" acceptCharset="UTF-8" method="post">
                                <FormControl name="utf8" type="hidden" value="✓" />
                                <FormControl type="hidden" name="_method" value="PUT" />
                                <FormControl type="hidden" name="authenticity_token" value={Functions.getMetaContent("csrf-token")} />

                                <FormControl type="hidden" value={this.props.resetPasswordToken} name="user[reset_password_token]" />

                                <FormGroup className="field" controlId="user_password">
                                    <ControlLabel>New password</ControlLabel><br />
                                    <em>(6 characters minimum)</em><br />
                                    <FormControl autoFocus="autofocus" autoComplete="off" type="password" name="user[password]" />
                                </FormGroup>

                                <FormGroup className="field" controlId="user_password_confirmation">
                                    <ControlLabel>Confirm new password</ControlLabel><br />
                                    <FormControl autoComplete="off" type="password" name="user[password_confirmation]" />
                                </FormGroup>

                                <FormGroup className="actions">
                                    <Button type="submit" name="commit" data-disable-with="Change my password">Change my password</Button>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/ResetPassword.jsx.erb